export default __webpack_public_path__ + "static/media/poster-costa-rica.e91437c9.png";